import { ChangeDetectorRef, Component, ElementRef, Renderer2, ViewContainerRef } from '@angular/core';
import { Subscription } from "sharedFeatures/sharedModels";
import { WindowComponent } from "sharedFeatures/window";
import { BillingDetailsComponent } from './billing-details.component';

@Component({
    selector: 'billing-subscription-win',
    templateUrl: './billing-subscription-win.component.html',
    styleUrls: ['../window/window.component.less']
})
export class BillingSubscriptionWinComponent extends WindowComponent {

    UserSubscription: Subscription = new Subscription();

    constructor(element: ElementRef,
        r: Renderer2,
        viewContainerRef: ViewContainerRef,
        chDet: ChangeDetectorRef
    ) {

        super(element, r, viewContainerRef, chDet);

        this.height = -1;

        this.showClose = true;

        this.title = '';

        this.cornerRadius = 0;

        //this.isModal = true;

        this.topMargin = 20;

        this.windowContentBody = BillingDetailsComponent;
    }

    getBodyComponent(): BillingDetailsComponent {

        return <BillingDetailsComponent>super.getBodyComponent();

    }

    refreshSubscriptions(callback: Function): void {
        this.getBodyComponent().loadSubscriptions(callback);
    }

}